import React from "react";
import ReactECharts from "echarts-for-react";

const IndusBenchMark = () => {
  const option = {
    title: {
      text: "Industry Benchmarking",
      left: "center",
      textStyle: {
        color: "#333",
        fontSize: 18,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      bottom: 0,
      textStyle: {
        color: "#333",
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      axisLabel: {
        color: "#333",
      },
      max: 100, // 100% se zyada value dikhane ke liye
      splitLine: {
        show: true,
        lineStyle: {
          color: "#ccc", // Grid line color
          type: "dashed", // Dashed grid lines
        },
      },
    },
    yAxis: {
      type: "category",
      data: ["Your Cost Structure by Year", "Your Industry Cost Structure"],
      axisLabel: {
        color: "#333",
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#ccc", // Grid line color
          type: "dashed", // Dashed grid lines
        },
      },
    },
    series: [
      {
        name: "Wages",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [29, 27],
        color: "#4CAF50",
      },
      {
        name: "Purchases/COGS",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [19, 57],
        color: "#1976D2",
      },
      {
        name: "Rent",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [1, 2],
        color: "#D32F2F",
      },
      {
        name: "Utilities",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [1, 1],
        color: "#9C27B0",
      },
      {
        name: "Depreciation",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [1, 4],
        color: "#FFC107",
      },
      {
        name: "Other",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [38, 7],
        color: "#FF5722",
      },
      {
        name: "Profit",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [12, 3],
        color: "#2E7D32",
      },
    ],
    backgroundColor: "#fff",
  };

  return <ReactECharts option={option} style={{ height: "400px", width: "100%" }} />;
};

export default IndusBenchMark;
